// generate colors for sunburst graph, each naic gets a unique hue, as naics level drills down, gets lighter
export const getRandomColorByHue = (h, naics) => {
    let hue = h;
    //let hue = h + Math.floor(Math.random() * 40) - 20;
    //let s = Math.floor(Math.random() * 100);
    let s = 80;
    let l = Math.floor(Math.random() * 100);
    if (naics == 2) {
        s = 100;
        l = 20 + Math.floor(Math.random() * 10);
    } else if (naics == 3) {
        //s = 60 + Math.floor(Math.random() * 40);
        l = 30 + Math.floor(Math.random() * 30);
    } else if (naics == 4) {
        //s = 60 + Math.floor(Math.random() * 40);
        l = 60 + Math.floor(Math.random() * 10);
    }
    const color = 'hsl(' + hue + ', ' + s + '%, ' + l + '%)';
    return color;
};
export const notExist = (array, naics) => {
    //if obj not in the array return true otherwise return false
    for (let i = 0; i < array.length; i++) {
        if (array[i].naics == naics) {
            return false;
        }
    }
    return true;
};
export const build2Layer = (data, root) => {
    for (let key in data) {
        let record = data[key];
        if (record.naics_2 && notExist(root["children"], record.naics_2)) {
            let node = {
                "title": record.naics_title_2,
                "naics": record.naics_2,
                "spent": record.spent_total_2 > 0 ? record.spent_total_2 : "(masked)",
                "highlighted": record.highlighted_2,
                "vendor": record.vendor_total_2,
                "university_emp_mean": record.university_emp_mean_2,
                "university_wage_mean": record.university_wage_mean_2,
                "national_emp_mean": record.national_emp_mean_2,
                "national_wage_mean": record.national_wage_mean_2,
                "definition": record.definition_2,
                "children": []
            };
            root["children"].push(node);
        }
    }
    return root;
};
export const build3Layer = (data, array) => {
    for (let i = 0; i < array.length; i++) {
        for (let key in data) {
            let record = data[key];
            if (record.naics_2 == array[i].naics && notExist(array[i]["children"], record.naics_3)) {
                let node = {
                    "title": record.naics_title_3,
                    "naics": record.naics_3,
                    "spent": record.spent_total_3,
                    "highlighted": record.highlighted_3,
                    "definition": record.definition_3,
                    "vendor": record.vendor_total_3,
                    "university_emp_mean": record.university_emp_mean_3,
                    "university_wage_mean": record.university_wage_mean_3,
                    "national_emp_mean": record.national_emp_mean_3,
                    "national_wage_mean": record.national_wage_mean_3,
                    "children": []
                };
                array[i]["children"].push(node);
            }
        }
        if (array[i].spent > 0) {
            let sum3Naics = array[i]["children"].reduce((sum, naics3) => { return sum + naics3.spent }, 0);
            let spentGap = array[i].spent - sum3Naics;
            if (spentGap > 0) {
                let gapNode = {
                    "title": "gap",
                    "spent": spentGap,
                    "children": []
                };
                array[i]["children"].push(gapNode);
            }
        }
    }
};
export const build4Layer = (data, array) => {
    for (let i = 0; i < array.length; i++) {
        array[i]["children"].forEach((node3) => {
            if (node3.title != "gap") {
                for (let key in data) {
                    let record = data[key];
                    if (record.naics_3 == node3.naics && record.naics_4 && notExist(node3["children"], record.naics_4)) {
                        let node = {
                            "title": record.naics_title_4,
                            "naics": record.naics_4,
                            "highlighted": record.highlighted_4,
                            "definition": record.definition_4,
                            "vendor": record.vendor_total_4,
                            "university_emp_mean": record.university_emp_mean_4,
                            "university_wage_mean": record.university_wage_mean_4,
                            "national_emp_mean": record.national_emp_mean_4,
                            "national_wage_mean": record.national_wage_mean_4,
                            "spent": record.spent_total_4,
                            "size": record.spent_total_4
                        };
                        node3["children"].push(node);
                    }
                }
                //if naics_3 is the last level, remove its children attr and add size
                /*if (node3["children"].length < 1) {
                    node3["size"] = node3.spent;
                    delete node3.children;
                }*/
                if (node3.spent > 0) {
                    let sum4Naics = node3["children"].reduce((sum, naics4) => { return sum + naics4.size }, 0);
                    let spentGap = node3.spent - sum4Naics;
                    if (spentGap > 0) {
                        let gapNode = {
                            "title": "gap",
                            "size": spentGap
                        };
                        node3["children"].push(gapNode);
                    }
                }
            } else {
                // pass gap to 4-th level
                node3["children"].push({ "title": "gap", "size": node3.spent });
            }
        });
    }
};
export const buildHierarchy = (data) => {
    let root = { "title": "root", "children": [] };
    root = build2Layer(data, root);
    build3Layer(data, root["children"]);
    build4Layer(data, root["children"]);
    return root;
};
export const colorSunburst = (root) => {
    let hue = 360 / root["children"].length;
    for (let i = 0; i < root["children"].length; i++) {
        root["children"][i].color = getRandomColorByHue((i + 1) * hue, 2);
        if (root["children"][i].spent == "(masked)") {
            root["children"][i].color = "#fff";
            //let masked have the same effect with gap(cannot be clicked)
            root["children"][i].title = "gap";
        }
        root["children"][i]["children"].forEach((node3) => {
            node3.color = getRandomColorByHue((i + 1) * hue, 3);
            if (node3.title == "gap") {
                node3.color = "#fff";
            }
            if (node3.children) {
                node3.children.forEach((node4) => {
                    node4.color = getRandomColorByHue((i + 1) * hue, 4);
                    if (node4.title == "gap") {
                        node4.color = "#fff";
                    }
                });
            }
        });
    }
    return root;
};
// give fill-opacity attr for each arc of sunburst graph
export const updateData = (data, parentPath) => {
    if (data.children) {
        data.children.map(child => updateData(child, parentPath));
    }
    data.style = {
        ...data.style,
        fillOpacity: parentPath && !parentPath[data.naics] ? 0.2 : 1
    };
    return data;
};